export const VIEW_SAMPLE_PROJECT_USER_PROPERTY_KEY =
	'jira.onboarding.view.sample.project.cta.tenant.CLOUD_ID';

export const SAMPLE_PROJECT_SESSION_STORE_KEY = 'sampleProjectSessionStoreKey';

export const SAMPLE_PROJECT_CTA_PROPERTY = 'sampleProjectCtaProperty';
export const SAMPLE_PROJECT_NUDGES_PROPERTY = 'sampleProjectNudgesProperty';
export const SAMPLE_PROJECT_NAV_NUDGE_PROPERTY = 'sampleProjectNavNudgeProperty';

export type SampleProjectSessionKey =
	| typeof SAMPLE_PROJECT_CTA_PROPERTY
	| typeof SAMPLE_PROJECT_NUDGES_PROPERTY
	| typeof SAMPLE_PROJECT_NAV_NUDGE_PROPERTY;
